import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';

import { Store } from '@ngrx/store';

import { BasePageComponent } from '../base-page';
import { IAppState } from '../../interfaces/app-state';
import { HttpService } from '../../services/http/http.service';

@Component({
  selector: 'page-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class PageSettingsComponent extends BasePageComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(
    store: Store<IAppState>,
    httpSv: HttpService
  ) {
    super(store, httpSv);

    this.pageData = {
      title: 'Settings',
      key: '',
      loaded: false,
      breadcrumbs: [
        {
          title: 'Dashboards',
          key: '',
          route: 'dashboard'
        },
        {
          title: 'Settings',
          key: ''
        }
      ]
    };
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit() {
    this.setLoaded();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
